import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

/** Infobulle à droite quand la sidebar est rétractée. */
export default function SidebarNavTooltip({ collapsed, label, children }) {
  if (!collapsed || !label) return children;

  return (
    <Tooltip delayDuration={200}>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent
        side="right"
        sideOffset={10}
        className="border-slate-700 bg-slate-900 text-xs font-medium text-white shadow-lg"
      >
        {label}
      </TooltipContent>
    </Tooltip>
  );
}
